module.exports = __webpack_public_path__ + "static/fish-curve-ea25fae6a727ac3e26941aff4d70d6b8.webm";